import React from 'react';
import {
  FaTruckMoving,
  FaBuilding,
  FaStore,
  FaMapMarkedAlt,
  FaBoxOpen,
  FaClipboardList,
  FaSnowflake,
  FaLeaf,
  FaBroom,
  FaTruckPickup,
  FaMotorcycle
} from 'react-icons/fa';
import './Home.css';

const services = {
  moving: [
    {
      icon: <FaTruckMoving size={24} className="me-2 text-warning" />,
      title: 'Residential & Apartment Moves',
      description: 'We move houses, apartments, and condos with care and efficiency.'
    },
    {
      icon: <FaBuilding size={24} className="me-2 text-warning" />,
      title: 'Office & Corporate Relocations',
      description: 'Professional office and business relocations with minimal downtime.'
    },
    {
      icon: <FaStore size={24} className="me-2 text-warning" />,
      title: 'Store & Retail Equipment Transfer',
      description: 'We handle store, warehouse, and retail logistics with precision.'
    },
    {
      icon: <FaMapMarkedAlt size={24} className="me-2 text-warning" />,
      title: 'Local & Long-Distance Moving',
      description: "Whether it's local or across provinces, we've got you covered."
    },
    {
      icon: <FaBoxOpen size={24} className="me-2 text-warning" />,
      title: 'Packing, Unpacking & Assembly',
      description: 'We help pack, unpack, assemble, and reassemble your belongings.'
    },
    {
      icon: <FaClipboardList size={24} className="me-2 text-warning" />,
      title: 'Inventory & Logistics Support',
      description: 'Inventory checks, item tracking, and logistics planning assistance.'
    }
  ],
  home: [
    {
      icon: <FaSnowflake size={24} className="me-2 text-warning" />,
      title: 'Snow Removal',
      description: 'Professional snow clearing services for driveways, walkways, and properties.'
    },
    {
      icon: <FaLeaf size={24} className="me-2 text-warning" />,
      title: 'Lawn Mowing',
      description: 'Keep your yard fresh and neat with our routine lawn mowing service.'
    },
    {
      icon: <FaBroom size={24} className="me-2 text-warning" />,
      title: 'General Cleaning',
      description: 'Thorough home or office cleaning tailored to your schedule.'
    }
  ],
  deliveries: [
    {
      icon: <FaTruckPickup size={24} className="me-2 text-warning" />,
      title: 'Car & Auto Deliveries',
      description: 'Safe, insured car transport across cities and provinces.'
    },
    {
      icon: <FaMotorcycle size={24} className="me-2 text-warning" />,
      title: 'Small Item Drop-Offs',
      description: 'We deliver documents, electronics, or packages right to your door.'
    }
  ]
};

const Services = () => {
  return (
    <div
      className="p-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container bg-dark bg-opacity-75 p-4 rounded animate__animated animate__fadeIn">
        <h2 className="text-warning text-center mb-4">🚚 Our Services</h2>

        {/* Moving Services */}
        <h4 className="text-white mt-4 mb-3">📦 Moving Services</h4>
        <div className="row g-3">
          {services.moving.map((service, index) => (
            <div className="col-md-6" key={`moving-${index}`}>
              <div className="card bg-secondary bg-opacity-10 border-0 p-3 h-100 service-card">
                <h5 className="text-warning d-flex align-items-center">
                  {service.icon} {service.title}
                </h5>
                <p className="text-white small">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Home Services */}
        <h4 className="text-white mt-5 mb-3">🏠 Home Services</h4>
        <div className="row g-3">
          {services.home.map((service, index) => (
            <div className="col-md-6" key={`home-${index}`}>
              <div className="card bg-secondary bg-opacity-10 border-0 p-3 h-100 service-card">
                <h5 className="text-warning d-flex align-items-center">
                  {service.icon} {service.title}
                </h5>
                <p className="text-white small">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Delivery Services */}
        <h4 className="text-white mt-5 mb-3">📦 Delivery Services</h4>
        <div className="row g-3">
          {services.deliveries.map((service, index) => (
            <div className="col-md-6" key={`delivery-${index}`}>
              <div className="card bg-secondary bg-opacity-10 border-0 p-3 h-100 service-card">
                <h5 className="text-warning d-flex align-items-center">
                  {service.icon} {service.title}
                </h5>
                <p className="text-white small">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
